import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, TextField} from '@mui/material';
import {sentAppUserNotification} from "../../services";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import Strings from "../../assets/strings";
import LoadingProgress from "../../components/LoadingProgress";


export default function EnviarNotificacion({ companiaId, onClose}:{ companiaId?:number, onClose:()=>void}){

    const [loading, setLoading] = useState(false);
    const [titulo, setTitulo] = useState("");
    const [mensaje, setMensaje] = useState("");

    const enviar = (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setLoading(true)
        if(companiaId && mensaje) {
            sentAppUserNotification({
                companiaId,
                titulo,
                mensaje
            }).then(res => {
                setTitulo("")
                setMensaje("")
                onClose()
            })
                .catch(() => {
                })
                .finally(() => setLoading(false))
        }
    };


    return (
        <>

            <Dialog  open={!!companiaId} fullWidth maxWidth={"xs"} disableEscapeKeyDown>
                <TopBarDialog title={Strings.enviar +" "+Strings.notificacion} onClose={onClose} nofullScreen/>
                <DialogContent>
                    {loading && <LoadingProgress vh={false} />}
                    <form  id={"formNoti"} onSubmit={enviar}>
                        <TextField label={"Título"} sx={{mb:2}} fullWidth value={titulo} onChange={({target})=>setTitulo(target.value)} />
                        <TextField label={"Mensaje"}  multiline rows={2} fullWidth value={mensaje} onChange={({target})=>setMensaje(target.value)} />

                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="warning" variant={"text"}>{Strings.cancelar}</Button>
                    <Button  disabled={loading || !titulo || !mensaje} type="submit" form={"formNoti"} color="primary" variant={"outlined"} >
                        {Strings.enviar}
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    );
}
